<template>
  <div class="content">
    <h1 class="title">About</h1>

    <p>
      A Recipe manager.  Source available at <a href="https://source.elbert.us/dan/parsley">https://source.elbert.us</a>.
    </p>

    <p>
      Parsley is released under the MIT License.  All code &copy; Dan Elbert 2024.
    </p>

    <p>
      Food data provided by:<br/>
      <cite>
        US Department of Agriculture, Agricultural Research Service, Nutrient Data Laboratory. USDA National Nutrient Database for Standard Reference, Release 28. Version Current:  September 2015.  Internet:  <a href="http://www.ars.usda.gov/nea/bhnrc/ndl">http://www.ars.usda.gov/nea/bhnrc/ndl</a>
      </cite>
    </p>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
</style>